import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import Cropper from 'cropperjs';
import { fromEvent } from 'rxjs';
import { first } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { cropperConfig } from './cropper-config';

@Component({
    selector: 'app-image-crop',
    templateUrl: './image-crop.component.html',
    styleUrls: ['./image-crop.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageCropComponent implements OnInit {
    @ViewChild('image') imageRef: ElementRef;
    cropper: Cropper;

    private cropperConfig: Cropper.Options = cropperConfig;
    imagePreview: any;
    public imageBlob: Blob;

    constructor(public modalRef: BsModalRef) {

    }

    ngOnInit() {
        const url = URL.createObjectURL(this.imagePreview);
        fromEvent(this.imageRef.nativeElement, 'load')
            .pipe(first())
            .subscribe(() => {
                this.cropper = new Cropper(this.imageRef.nativeElement, this.cropperConfig);
        });
        this.imageRef.nativeElement.src = url;
    }

    onDeclineClick(): void {
        this.cropper.destroy();
        this.modalRef.hide();
    }

    crop(): void {
        this.imageRef.nativeElement.src = '';
        this.cropper
            .getCroppedCanvas()
            .toBlob(blob => {
                this.imageBlob = blob;
                this.cropper.destroy();
                this.modalRef.hide();
            });
    }

}
